<template>
  <div class="milepost">
    <div class="header">
      <div class="title">畅月里程碑</div>
      <div class="border"></div>
    </div>
    <div class="body">
      <van-steps direction="vertical" :active="9">
        <van-step class="item" v-for="item in milepostTopList" :key="item.id">
          <div class="date">{{ item.date }}</div>
          <div class="text">{{ item.text }}</div>
        </van-step>
      </van-steps>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

export default {
  setup() {
    return reactive({
      milepostTopList: [
        {
          id: 8,
          date: "2012",
          text: "成功实施多项知名企业大型网络机房系统工程项目",
        },
        {
          id: 7,
          date: "2013",
          text: "建立在安防领域具有深厚技术力量的专业队伍，实施宝山第一个封闭式小区管理智能化小区",
        },
        {
          id: 6,
          date: "2014",
          text: "致力于将“何伟安防”打造成上海地区安防行业著名品牌",
        },
        {
          id: 5,
          date: "2015",
          text: "成立畅居通信公司、并聚集各类技术人才，组建专业设计、施工及服务的团队，实施宝山区农村治安联网智能门禁",
        },
        {
          id: 4,
          date: "2016",
          text: "顺利进行宝山区雪亮工程、农村治安防范等多个政府项目建设、并于同年建设高效、专业的售后服务体系，售后管理平台上线",
        },
        {
          id: 3,
          date: "2017",
          text: "以细节、诚信走出上海，参与全国众多品牌汽车行业的智能系统及多个重点政府实施项目建设，与各大厂商签订战略合作，为企业发展创造良好的业绩",
        },
        {
          id: 2,
          date: "2020",
          text: "上海畅居智慧信息技术有限公司荣获五星售后服务体系认证证书、政府采购优秀供应商、高新技术企业等称号，并通过ISO9001国际质量体系认证等多项国内权威认证",
        },
        {
          id: 1,
          date: "2022",
          text: "物联网设备对接移动软件，打造智慧社区、智慧物业管理系统",
        },
      ],
    });
  },
};
</script>

<style scoped>
.milepost {
  width: 100%;
}
.header .title {
  font-size: 16px;
  text-align: center;
  margin-top: 24px;
}
.header .border {
  width: 16px;
  height: 2px;
  background: #248efb;
  margin: 4px auto 0;
}

.body {
  width: 92vw;
  margin: 16px auto 0;
}
:deep(.van-step__title) {
  display: flex;
}
.date {
  font-size: 14px;
  color: #248efb;
  margin-right: 12px;
}
:deep(.van-step--finish .van-step__circle),
:deep(.van-step--finish .van-step__line) {
  background: #248efb;
}
:deep(.van-step__circle) {
  width: 6px;
}
.text {
  font-size: 10px;
  color: #3d3d3d;
}
:deep(.van-step--vertical .van-step__line) {
  top: 17px;
}
:deep(.van-step--vertical:not(:last-child):after) {
  border: none;
}
</style>
